import { WorkflowTimeline } from './project';
import { PDF_QC } from './report';

export enum KitStatus {
  CREATED = 'CREATED',
  UNACTIVATED = 'UNACTIVATED',
  ACTIVATED = 'ACTIVATED',
  SENT_OUT = 'SENT_OUT',
  KIT_RECEIVED = 'KIT_RECEIVED',
  ALIQUOTED = 'ALIQUOTED',
  DNA_EXTRACTED = 'DNA_EXTRACTED',
  SEQUENCING = 'SEQUENCING',
  COMPLETED = 'COMPLETED',
  FFQ_SURVEY_COMPLETED = 'FFQ_SURVEY_COMPLETED',
  UNDER_SUPPORT = 'UNDER_SUPPORT',
  REPORT_READY = 'REPORT_READY',
  CLINIC_RECEIVED = 'CLINIC_RECEIVED',
  PUBLISHED = 'PUBLISHED',
  REPORT_ERROR = 'REPORT_ERROR',
  REPORT_UNDER_SUPPORT = 'REPORT_UNDER_SUPPORT',
}
export enum KitStatusExpand {
  REPORT_READY = 'REPORT_READY',
}

export const kitStatusColor = {
  [KitStatus.CREATED]: ['#232567', '#EEEEF3'],
  [KitStatus.UNACTIVATED]: ['#FF634E', '#FFF3F1'],
  [KitStatus.ACTIVATED]: ['#00AB00', '#EBF9EB'],
  [KitStatus.SENT_OUT]: ['#007AE7', '#EBF5FD'],
  [KitStatus.KIT_RECEIVED]: ['#007AE7', '#EBF5FD'],
  [KitStatus.ALIQUOTED]: ['#232567', '#EEEEF3'],
  [KitStatus.DNA_EXTRACTED]: ['#232567', '#EEEEF3'],
  [KitStatus.SEQUENCING]: ['#FFAC00', '#FFF9EB'],
  [KitStatus.UNDER_SUPPORT]: ['#da2e9a', '#fceff7'],
  [KitStatus.COMPLETED]: ['#00AB00', '#EBF9EB'],
  [KitStatus.REPORT_READY]: ['#232567', '#EEEEF3'],
  [KitStatus.REPORT_UNDER_SUPPORT]: ['#FFAC00', '#FFF3F1'],
  [KitStatus.REPORT_ERROR]: ['#FF634E', '#FFF3F1'],
};

export const reportQCStatusColor: Record<string, string[]> = {
  SUCCESS: ['#00AB00', '#EBF9EB'],
  FAILED: ['#FF634E', '#FFF3F1'],
};
export const pdfQcStatusColor = {
  [PDF_QC.FAILED]: { color: 'var(--light-error)', textColor: 'var(--error)' },
  [PDF_QC.SUCCESS]: {
    color: 'var(--success-hover)',
    textColor: 'var(--success)',
  },
  CUSTOMIZED: {
    color: 'var(--light-link)',
    textColor: 'var(--link)',
  },
};

export const AllowDnaExtractionColor: Record<string, string[]> = {
  yes: ['#00AB00', '#EBF9EB'],
  no: ['#FF634E', '#FFF3F1'],
};

export enum KitFtpType {
  PRE = 'PRE',
  POST = 'POST',
}

export enum KIT_TYPES {
  AMD = 'AMD',
  BME = 'BME',
  FTP = 'FTP',
  ALL = 'ALL',
}

export enum KIT_SAMPLE_TYPE {
  DNA = 'DNA',
  NORMAL = 'NORMAL',
}

export enum KitAction {
  CHANGE_STATUS = 'CHANGE_STATUS',
  GET_SAMPLES = 'GET_SAMPLES',
}

export enum QueuedSampleType {
  KIT = 'KIT',
  SEQUENCING = 'SEQUENCING',
}

export const SPECIAL_TABS = {
  ACTIVATED_BY_CUSTOMER: 'ACTIVATED_BY_CUSTOMER',
};

export const STATUS_BASED_ON_TIMELINE_MANAGEMENT: Record<any, any> = {
  [WorkflowTimeline.AMD]: {
    [KitStatus.UNACTIVATED]: 0,
    [KitStatus.SENT_OUT]: 1,
    [KitStatus.KIT_RECEIVED]: 2,
    [KitStatus.FFQ_SURVEY_COMPLETED]: 3,
    [KitStatus.DNA_EXTRACTED]: 4,
    [KitStatus.SEQUENCING]: 5,
    [KitStatus.COMPLETED]: 6,
    [KitStatus.REPORT_READY]: 7,
  },
  [WorkflowTimeline.RESEARCH]: {
    [KitStatus.UNACTIVATED]: 0,
    [KitStatus.KIT_RECEIVED]: 1,
    [KitStatus.ALIQUOTED]: 2,
    [KitStatus.DNA_EXTRACTED]: 3,
    [KitStatus.SEQUENCING]: 4,
    [KitStatus.COMPLETED]: 5,
    [KitStatus.REPORT_READY]: 6,
  },
  [WorkflowTimeline.BME]: {
    [KitStatus.UNACTIVATED]: 0,
    [KitStatus.ACTIVATED]: 1,
    [KitStatus.KIT_RECEIVED]: 2,
    [KitStatus.DNA_EXTRACTED]: 3,
    [KitStatus.SEQUENCING]: 4,
    [KitStatus.COMPLETED]: 5,
    [KitStatus.REPORT_READY]: 6,
  },
  [WorkflowTimeline.FFH]: {
    [KitStatus.UNACTIVATED]: 0,
    [KitStatus.SENT_OUT]: 1,
    [KitStatus.KIT_RECEIVED]: 2,
    [KitStatus.DNA_EXTRACTED]: 3,
    [KitStatus.SEQUENCING]: 4,
    [KitStatus.COMPLETED]: 5,
    [KitStatus.REPORT_READY]: 6,
  },
  [WorkflowTimeline.FMT]: {
    [KitStatus.UNACTIVATED]: 0,
    [KitStatus.KIT_RECEIVED]: 1,
    [KitStatus.DNA_EXTRACTED]: 2,
    [KitStatus.SEQUENCING]: 3,
    [KitStatus.COMPLETED]: 4,
    [KitStatus.REPORT_READY]: 5,
  },
  [WorkflowTimeline.EXTERNAL]: {
    [KitStatus.UNACTIVATED]: 0,
    [KitStatus.KIT_RECEIVED]: 1,
    [KitStatus.DNA_EXTRACTED]: 2,
    [KitStatus.SEQUENCING]: 3,
    [KitStatus.UNDER_SUPPORT]: 4,
    [KitStatus.COMPLETED]: 5,
    [KitStatus.REPORT_READY]: 6,
  },
};
